module.exports = __webpack_public_path__ + "img/new14-5.7df1b548.jpg";